module.exports = __webpack_public_path__ + "static/img/147_TO8_1857_og.dda6e05.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/147_TO8_1857_og.jpg
// module id = Dn9Y
// module chunks = 0